export const REPORT_TYPE = {
  Allergy: 1,
  SideEffect: 2,
  MedicalHistory: 3,
  Other: 9,
} as const;

export type Patient = {
  address?: string | null;
  postalCode?: string | null;
  birthDate?: string | null;
  bloodType?: string | null;
  emergency?: string | null;
  name?: string | null;
  kana?: string | null;
  sex: string;
  tel?: string | null;
  weight?: string | null;
};

export type Period = {
  from?: Date;
  to: Date;
};
